import TextFieldControl from "components/form/TextFieldControl";
import CompetencyMapControl from "pages/Testing/view/components/CompetencyMapControl";
import { CompetencyMapOptionList } from "pages/Testing/view/types";

interface ICompetencyMapInfoProps {
  competencyMaps: CompetencyMapOptionList;
  isEditing: boolean;
  competencyMapsLoading: boolean;
}

const CompetencyMapInfo = ({ competencyMaps, isEditing, competencyMapsLoading }: ICompetencyMapInfoProps) => {
  return (
    <>
      <CompetencyMapControl
        competencyMaps={competencyMaps}
        isEditing={isEditing}
        competencyMapsLoading={competencyMapsLoading}
        type='trial'
      />
      <TextFieldControl
        name='competencyMapComment'
        label='Комментарий к карте компетенций'
        minRows={7}
        multiline
        disabled
      />
      <TextFieldControl
        name='competencyMapGrades'
        label='Грейд карты компетенций'
        disabled
      />
    </>
  );
};

export default CompetencyMapInfo;
